import { SocialMediaStoryController } from './social-media-story.controller'

function socialMediaStory () {
  return {
    restrict: 'E',
    controller: SocialMediaStoryController,
    templateUrl: '/arts/directives/social-media-story/social-media-story.html?$$REVISION$$',
    scope: {
      imageUrl: '<',
      materials: '<',
      selectedIndex: '<'
    }
  }
}

export { socialMediaStory }
